module.exports = __webpack_public_path__ + "img/bell.00525da5.svg";